'use client'; // src/index.ts

import { useMemo } from "react";

function assignRef(ref, value) {
  if (ref == null) return;

  if (typeof ref === "function") {
    ref(value);
    return;
  }

  try {
    ref.current = value;
  } catch (error) {
    throw new Error("Cannot assign value '".concat(value, "' to ref '").concat(ref, "'"));
  }
}

function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    refs.forEach(function (ref) {
      assignRef(ref, node);
    });
  };
}

function useMergeRefs() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }

  return useMemo(function () {
    return mergeRefs.apply(void 0, refs);
  }, refs);
}

export { assignRef, mergeRefs, useMergeRefs };